import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Card, CardContent, Typography, TextField, Button, Select, MenuItem } from '@mui/material';
import { gridSpacing } from '../../constant/Constants';
import { useMediaQuery, useTheme } from '@mui/material';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import { makeStyles } from '@mui/styles';
import { initAccountData } from '../../utils/object/Account';
import { validateTargetNumber, validateTransferMessage } from '../../utils/regex/Regex';
import { useDispatch, useSelector } from 'react-redux';
import { showAlert } from '../../redux/create-actions/AlertAction';
import { showOtpIntrabankTransfer } from '../../redux/create-actions/OtpAction';
import { MoneyFormatCustom, ContractNumberFormatCustom, deleteAccents, checkSearchMethod } from '../../utils/function/Function'
import { initTransferMessageData } from '../../utils/object/TransferMessage';
import { closeLoadingApi, openLoadingApi } from '../../redux/create-actions/LoadingAction';
import FontSize from '../../layouts/FontSize';
import Color from '../../layouts/Color';
import { graphGetAllContractByCustomer, graphGetCardInfo } from '../../services/Contract';
import { graphGenOtp } from '../../services/OneTimePassword';

const useStyles = makeStyles(function (theme) {
    return {
        gridContainer: {
            [theme.breakpoints.up("sm")]: {
                paddingLeft: '100px',
                paddingRight: '100px'
            },
            [theme.breakpoints.up("md")]: {
                paddingLeft: '150px',
                paddingRight: '150px'
            },
            [theme.breakpoints.up("lg")]: {
                paddingLeft: '200px',
                paddingRight: '200px'
            },
            [theme.breakpoints.only("xl")]: {
                paddingLeft: '400px',
                paddingRight: '400px'
            },
        },
    };
});

const paperStyle = { my: { xs: 1, md: 2 }, p: { xs: 1, md: 3 }, minHeight: '100%' };
const container = { mt: 1, textAlign: 'left' };
const buttonSubmit = {
    color: Color.Button,
    backgroundColor: Color.Dangerous,
    '&:hover': { background: Color.Button, color: Color.Dangerous }
};

export default function IntrabankForm(props) {
    const theme = useTheme();
    const classes = useStyles();
    const dispatch = useDispatch();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const data = useSelector(state => state.otp.data)

    const [contract, setContract] = useState(null);
    const [contractID, setContractID] = useState(null)
    const [listContract, setListContract] = useState([]);
    const [accountErrorText, setAccountErrorText] = useState('');
    const [messageErrorText, setMessageErrorText] = useState('');
    const [accountData, setAccountData] = useState(initAccountData(''));
    const [messageData, setMessageData] = useState(initTransferMessageData(''));
    const [targetName, setTargetName] = useState("");
    const [amount, setAmount] = useState("");
    const [cbsNumber, setCBSNumber] = useState("");

    useEffect(() => {
        if (data.sourceNumber === "") {
            setAmount("");
            setMessageData({ ...messageData, message: '', isTransferMessageError: false });
            setTargetName("");
            setAccountData({ ...accountData, account: '', isAccountError: false });
            setAccountErrorText('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.sourceNumber]);

    useEffect(() => {
        if (contractID !== null && listContract.length !== 0) {
            setContract(listContract.filter((e) => e.id === contractID)[0]);
        }
    }, [contractID, listContract])

    useEffect(() => {
        dispatch(openLoadingApi());

        const contractType = ["PREPAID"]
        const promise = graphGetAllContractByCustomer(contractType);
        promise.then((result) => {
            setContractID(result.items[0].id);
            setListContract(result.items);
            dispatch(closeLoadingApi());
        }).catch(error => {
            const err = JSON.parse(JSON.stringify(error))
            console.log(err);
            dispatch(closeLoadingApi());
        })
    }, [dispatch])

    const handleChangeAccount = (event) => {
        let value = event.target.value;
        if (value !== "") {
            let data = handleValidateAccount(value);
            setAccountData(data);
        } else {
            setAccountData({ ...accountData, account: '', isAccountError: false });
            setAccountErrorText('')
        }
    }

    const handleChangeMessage = (event) => {
        let value = deleteAccents(event.target.value);
        if (value !== "") {
            let data = handleValidateMessage(value)
            setMessageData(data)
        } else {
            setMessageData({ ...messageData, message: '', isTransferMessageError: false })
            setMessageErrorText("")
        }
    }

    function handleValidateMessage(message) {
        let result = validateTransferMessage(message);
        let data;
        if (!result) {
            data = { ...messageData, message: message, isTransferMessageError: true };
            setMessageData(data);
            setMessageErrorText("Please enter up to 200 characters");
        } else {
            data = { ...messageData, message: message, isTransferMessageError: false };
            setMessageData(data);
            setMessageErrorText("");
        }
        return data;
    }

    const handleChangeAmount = (event) => {
        let value = event.target.value;
        setAmount(value);
    }


    function handleValidateAccount(account) {
        let result = validateTargetNumber(account);
        let data;
        if (!result) {
            data = { ...accountData, account: account, isAccountError: true };
            setAccountData(data);
            setAccountErrorText("Error Account Format");
            setTargetName("");
        } else {
            data = { ...accountData, account: account, isAccountError: false };
            setAccountData(data);
            setAccountErrorText("");
            let alert = {
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                isOpen: true,
                severity: 'error',
                title: 'Error',
                message: '',

            };

            const searchMethod = checkSearchMethod(account)
            let promise = graphGetCardInfo(searchMethod, account);
            promise
                .then(result => {

                    if (result.status === '0') {
                        const res = result?.data?.cardInfo
                        setCBSNumber(res.cbsNumber)
                        setTargetName(res.embossedLastName);
                        setMessageData({ ...messageData, message: contract.embossingName + ' Transfer', isTransferMessageError: false });
                    }
                }).catch(function (error) {
                    const err = JSON.parse(JSON.stringify(error));
                    alert = { ...alert, message: err.response.errors[0].message }
                    dispatch(showAlert(alert));
                    setTargetName("");
                    setMessageData({ ...messageData, message: '', isTransferMessageError: false });
                })
        }
        return data;
    }
    const handleClick = () => {
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: '',

        };
        if (contract !== null && contractID !== null) {
            if (contract.way4Contract !== cbsNumber) {
                if (targetName === "") {
                    alert = { ...alert, message: "Please enter correct receiving account!" };
                    dispatch(showAlert(alert));
                    if (messageData === "") {
                        alert = { ...alert, message: "Please enter the message!" };
                        dispatch(showAlert(alert));
                    }
                } if (amount < 10000 || amount === "") {
                    alert = { ...alert, message: 'Amount must be at least 10000!' };
                    dispatch(showAlert(alert));
                } else {
                    dispatch(openLoadingApi())
                    let sendOtp = graphGenOtp();
                    sendOtp
                        .then(result => {
                            dispatch(closeLoadingApi())
    
                            if (result === 'SMS') {
                                alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code sent to your phone number " };
                                dispatch(showAlert(alert));
                                dispatch(showOtpIntrabankTransfer(contractID, cbsNumber, messageData.message, amount, "INTRABANK_TRANSFER"))
                            } else {
                                alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code in your Google Authenticator App" };
                                dispatch(showAlert(alert));
                                dispatch(showOtpIntrabankTransfer(contractID, cbsNumber, messageData.message, amount, "INTRABANK_TRANSFER"))
                            }
                        }).catch(function (error) {
                            const err = JSON.parse(JSON.stringify(error));
                            dispatch(closeLoadingApi())
                            alert = { ...alert, message: err.response.errors[0].message };
                            dispatch(showAlert(alert));
                        })
                }
            } else {
                alert = { ...alert, message: "Please choose an account other than the source account!" };
                dispatch(showAlert(alert));
            }
        } else {
            alert = {...alert, message: "You don't have a prepaid card to transfer money"};
            dispatch(showAlert(alert))
        }
    }

    const handleChangeContract = (event) => {
        setContractID(event.target.value);
    };

    return (
        <Paper variant="outlined" sx={paperStyle}>
            <Grid container alignContent="center" justifyContent="space-between">
                <Grid item>
                    <Button id="intrabank-transfer" endIcon={<MoveDownIcon />} sx={{ color: theme.typography.h3, cursor: 'default', fontSize: FontSize.Normal }}>
                        Intrabank Transfer
                    </Button>
                </Grid>
            </Grid>
            <Card>
                <CardContent>
                    <Grid container spacing={gridSpacing} className={classes.gridContainer} alignItems="center" justifyContent="center" sx={container}>
                        <Grid item sm={0} xs={0} md={3} xl={3} >
                            <Typography variant="h4"> From Account: </Typography>
                        </Grid>
                        <Grid item sm={12} xs={12} md={9} xl={9}>
                            <Select
                                fullWidth
                                labelId="cardnumberl-filter"
                                id="demo-simple-select-helper"
                                value={contractID ? contractID : null}
                                onChange={handleChangeContract}
                                size="medium"
                                sx={{
                                    '& .MuiInputBase-input': {
                                        bgcolor: theme.palette.background.default
                                    },
                                    bgcolor: theme.palette.background.default,
                                    textAlign: 'center'
                                }}
                            >
                                {(contract !== null && contractID !== null) ? (
                                    listContract?.map((contract) => {
                                        return (
                                            <MenuItem key={contract.id} id={contract.id} value={contract.id}>
                                                {(contract.contractNumber).slice(0, 4)}&emsp;{(contract.contractNumber).slice(4, 8).replace("__", "**")}&emsp;{(contract.contractNumber).slice(8, 12).replace("____", "****")}&emsp;{(contract.contractNumber).slice(12, 16)}
                                            </MenuItem>
                                        )
                                    })
                                ) : (
                                    <MenuItem value={null}>
                                        No Options
                                    </MenuItem>
                                )
                                }
                            </Select>
                        </Grid>
                        {matchDownSM ? (
                            <></>
                        ) : (
                            <Grid item sm={0} xs={0} md={3} xl={3}>
                                <Typography variant="h4"> To Account: </Typography>
                            </Grid>
                        )}
                        <Grid item sm={12} xs={12} md={9} xl={9}>
                            <TextField
                                fullWidth
                                required
                                id="account"
                                name="account"
                                label="To Account"
                                autoComplete="given-name"
                                variant="standard"
                                inputProps={{ style: { textAlign: `${matchDownSM ? 'center' : 'left'}` } }}
                                value={accountData.account}
                                error={accountData.isAccountError}
                                helperText={accountErrorText}
                                onChange={handleChangeAccount}
                                InputProps={{
                                    inputComponent: ContractNumberFormatCustom
                                }}
                            >

                            </TextField>
                        </Grid>
                        {targetName !== '' && (
                            <>
                                {matchDownSM ? (
                                    <></>
                                ) : (
                                    <Grid item sm={0} xs={0} md={3} xl={3}>
                                        <Typography variant="h4"> Full Name: </Typography>
                                    </Grid>
                                )}
                                <Grid item sm={12} xs={12} md={9} xl={9}>
                                    <TextField
                                        required
                                        id="standard-basic"
                                        label="Full Name"
                                        variant="standard"
                                        inputProps={{ style: { textAlign: `${matchDownSM ? 'center' : 'left'}`, color: theme.palette.primary[800] } }}
                                        fullWidth
                                        value={targetName}
                                    />
                                </Grid>
                            </>
                        )}
                        {matchDownSM ? (
                            <></>
                        ) : (
                            <Grid item sm={0} xs={0} md={3} xl={3}>
                                <Typography variant="h4"> Amount: </Typography>
                            </Grid>
                        )}
                        <Grid item sm={12} xs={12} md={9} xl={9}>
                            <TextField
                                fullWidth
                                required
                                id="amount"
                                name="amount"
                                label="Amount"
                                value={amount}
                                variant="standard"
                                onChange={handleChangeAmount}
                                InputProps={{
                                    inputComponent: MoneyFormatCustom
                                }}
                            >
                            </TextField>
                        </Grid>
                        {matchDownSM ? (
                            <></>
                        ) : (
                            <Grid item sm={0} xs={0} md={3} xl={3}>
                                <Typography variant="h4"> Message: </Typography>
                            </Grid>
                        )}
                        <Grid item sm={12} xs={12} md={9} xl={9}>
                            <TextField
                                fullWidth
                                required
                                id="message"
                                name="message"
                                label="Message"
                                value={messageData.message}
                                error={messageData.isTransferMessageError}
                                variant="standard"
                                helperText={messageErrorText}
                                onChange={handleChangeMessage}
                            ></TextField>
                        </Grid>
                        <Grid item sm={0} xs={0} md={3} xl={3}></Grid>
                        <Grid item sm={12} xs={12} md={9} xl={9}
                            sx={{
                                textAlign: `${matchDownSM ? 'center' : 'left'}`,
                            }}
                        >
                            <Button sx={buttonSubmit} variant="contained" onClick={handleClick} endIcon={<MoveDownIcon></MoveDownIcon>}>Transfer</Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Paper>
    )
}